import React from 'react'

export default ({ width = 100, height = 100 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
      <g id="workspace_icon" transform="translate(-349 -600)">
        <path id="Combined-Shape" d="M36.529,8a19.686,19.686,0,0,1,7.748,37.781c9.983,4.4,17.069,15.718,17.069,23.2,0,8.642-9.457,9.166-21.915,9.192H32.318C19.785,78.147,10,77.633,10,68.979c0-7.658,7.663-19.341,18.112-23.5A19.685,19.685,0,0,1,36.529,8Z" transform="translate(363 607)" fill="#f78a2c" fillRule="evenodd" opacity="0.88"/>
        <g id="Rectangle_1829" data-name="Rectangle 1829" transform="translate(349 600)" fill="none" stroke="#707070" strokeWidth="1" opacity="0">
          <rect width="100" height="100" stroke="none"/>
          <rect x="0.5" y="0.5" width="99" height="99" fill="none"/>
        </g>
      </g>
    </svg>
  )
}
